export default function getCustomPageLinksForAuth(linksArray) {
  let customLinks = {
    terms: "",
    policy: "",
  };

  for (let page = 0; page < linksArray.length; page++) {
    if (
      linksArray[page].path.match(/term/gi) ||
      linksArray[page].path.match(/terms-services/gi)
    ) {
      customLinks["terms"] = linksArray[page].path;
    }
    if (
      linksArray[page].path.match(/policy/gi) ||
      linksArray[page].path.match(/privacy/gi) ||
      linksArray[page].path.match(/privacy-policy/gi)
    ) {
      customLinks["policy"] = linksArray[page].path;
    }
  }

  return customLinks;
}
